import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css"; // Import AOS CSS
import "./Header.css";

import React, { useEffect } from "react";

import AOS from "aos";
import { assest } from "../../assest/assest"; // Adjust your asset import

const Header = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  // Define your URLs for each button
  const magazineUrl = 'https://emagazine.exposition.lk/';
  const competitionUrl = 'https://blog.exposition.lk/';
  const communityUrl = 'https://www.facebook.com/share/15rbLXL27P/';
  const industrialWeekUrl = 'https://www.facebook.com/share/15rbLXL27P/';

  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Side - Image */}
          <div className="col-md-6" data-aos="fade-up">
            <img src={assest.xx} alt="About Us" className="about-image img-fluid" />
          </div>

          {/* Right Side - Text Content */}
          <div className="col-md-6 text-light" data-aos="fade-up">
            <h2 className="about-title">
              About <span>Exposition</span>
            </h2>
            <p className="about-text">
              Exposition, organized by the Industrial Management Science Students' Association at the University of Kelaniya, has long been a premier platform where Management and IT converge. With a rich legacy spanning over two decades, it fosters innovation, collaboration, and advancements across industries.
            </p>
            <p className="about-text">
              Exposition Issue 20 bridges the evolving landscapes of technology and management, creating a space for in-depth discussions and impactful collaborations. By uniting thought leaders, industry professionals, and students, it sparks transformative ideas that shape the future of business and technology.
            </p>
          </div>
        </div>

        {/* 🟡 Cards Section */}
        <div className="row text-center mt-5">
          <div className="col-md-6 col-lg-3" data-aos="zoom-in">
            <div className="about-card">
              <img src={assest.xx} alt="Card 1" className="card-img-top" />
              <h4>Exposition Magazine</h4>
              <p>Exposition magazine includes a lineup of articles on the latest business trends, IT innovations, findings from surveys and research, and life experiences, written by professionals and undergraduates, alongside interviews with illustrious personalities that have a greater impact on corporate society.</p>
              <button
                className="about-btn"
                onClick={() => window.open(magazineUrl, '_blank')}
              >
                Read More
              </button>
            </div>
          </div>
          <div className="col-md-6 col-lg-3" data-aos="zoom-in">
            <div className="about-card">
              <img src={assest.x1} alt="Card 2" className="card-img-top" />
              <h4>Edify Inter-University Article Competition</h4>
              <p>Alongside the magazine, Exposition continues the third iteration of the Inter University Article Competition Edify 2023 to ignite the zeal of Sri Lankan university undergraduates’ minds empowering them to become future leaders and innovators in their respective fields.</p>
              <button
                className="about-btn"
                onClick={() => window.open(competitionUrl, '_blank')}
              >
                Read More
              </button>
            </div>
          </div>
          <div className="col-md-6 col-lg-3" data-aos="zoom-in">
            <div className="about-card">
              <img src={assest.x2} alt="Card 3" className="card-img-top" />
              <h4>Exposition Entrepreneurial Community (EEC)</h4>
              <p>Exposition Entrepreneurial Community serves as a dynamic platform facilitating interactions among the Department of Industrial Management, entrepreneurs, and industrial experts, actively fostering collaboration to drive economic growth and unlock prosperity.</p>
              <button
                className="about-btn"
                onClick={() => window.open(communityUrl, '_blank')}
              >
                Read More
              </button>
            </div>
          </div>
          <div className="col-md-6 col-lg-3" data-aos="zoom-in">
            <div className="about-card">
              <img src={assest.x3} alt="Card 4" className="card-img-top" />
              <h4>Exposition Industrial Week</h4>
              <p>Introducing the Industrial Week for the first time by Exposition, which provides a series of workshops and a career fair to empower aspiring entrepreneurs and undergraduates to explore a variety of career paths, network with industry professionals, and kickstart their professional journeys.</p>
              <button
                id="our-story"
                className="about-btn"
                onClick={() => window.open(industrialWeekUrl, '_blank')}
              >
                Read More
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Header;
